import "./Register.scss";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../helpers/withRouter";
import apiConfig from "../../config/api";
import { formatNumberHelper } from "../../helpers";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Icon,
  Input,
  List,
  Menu,
  Modal,
  notification,
  Pagination,
  Row,
  Select,
  Spin,
  Switch,
  Table,
  Tooltip,
  Upload,
  Progress
} from "antd";
import {
  Page,
  PageBottomBar,
  PageContent,
  PageFooter,
  PageHeader,
  PageTopBar,
} from "../../layouts/Private/components";
import {
    AdvancedTabs,
    Content,
    ContentTopBar,
    Filters,
    ModalClientCard,
    ModalRequestOpt,
    ModalRisk,
    ModalUbos,
    Sidebar,
} from './components'
import {ReportService, UploadProgressManager} from '../../services'
import {bajaClientesPromise, getClientsPromise, getRiskCLClientesPromise, getFiltersCLClientesPromise, uploadClientsPromise, uploadRelatedPromise, getAreasPromise} from './promises'
import {getParamsPromise} from '../AdminParams/promises'
import {getUsersByClientPromise} from '../../promises'
import uploadIcon from '../Batch/components/ModalAddBatchFile/drag-icon.png'
import excelFileIcon from './excel-file.png'
import ga from './ga'
import moment from 'moment'
import {globalContext} from '../../contexts'
import personIcon from '../Query/components/PersonCard/person-icon.png'
import entityIcon from '../Query/components/PersonCard/entity-icon.png'
import ImageResources from "../../layouts/commonComponent/components/ExternalResources/ImageResources";

const { Dragger } = Upload;

class Register extends Component {
  static contextType = globalContext;
  state = {
    breadcrumbs: this.getBreadcrumbs(),
    clients: [],
    currentPage: 1,
    filters: {},
    resultsPerPage: 10,
    isLoading: true,
    resultsTotalNum: -1,
    colors: {
      total: 0,
      black: 0,
      red: 0,
      orange: 0,
      yellow: 0,
      green: 0,
      na: 0,
    },
    colorsCake: { total: 0 },
    firstLoading: true,
    isModalRiskVisible: false,
    isModalUbosVisible: false,
    isModalUploadVisible: false,
    isModalUploadInactiveVisible: false,
    isModalUploadRelatedVisible: false,
    isModalReportVisible: false,
    selectedRecord: {},
    uploading: false,
    uploaded: false,
    uploadProgress: 0,
    uploadMinimized: false,
    activeUploadType: null,
    fileList: [],
    parametersClient: null,
    formularioInterno: true,
    processUF: false,
    resultsUpload: [],
    userAsig: null,
    users: [],
    filterFecAlerta: null,
    grupo: [],
    category: "CLIENTE",
    subclienteId: null,
    filterFalsosPositivos: null,
    errorsUpload: null,
    bajaFiles: null,
    selectedItems: [],
    chkAll: false,
    moreStyle: false,
    isAdvancedSearchVisible: false,
    modalTitleButtons: null,
    rut: null,
    recordsAction: [],
    filterCurrentUser: null,
    totalCurrentUser: 0,
    isSendAll: false,
    actionType: null,
    itemTable: null,
    areas: null,
    areasList: [],
    processName: null,
    uploadProcessed: 0,
    uploadTotal: 0
  };

  uploadUnsubscribe = null;

  localGenerateReport(type) {
    const { filters } = this.state;
    const { generateReport } = this.context;
    return generateReport(type, filters, this.finishReport.bind(this));
  }

  componentWillUnmount() {
    UploadProgressManager.setOnCompleteHook(null);

    if (this.uploadUnsubscribe) {
      this.uploadUnsubscribe();
      this.uploadUnsubscribe = null;
    }

    UploadProgressManager.ensureMinimizedOnLeave();
  }

  applyUploadState = (uploadState) => {
    const nextState = {
      uploading: uploadState.uploading,
      uploaded: uploadState.uploaded,
      uploadProgress: uploadState.uploadProgress,
      uploadProcessed: uploadState.uploadProcessed,
      uploadTotal: uploadState.uploadTotal,
      uploadMinimized: uploadState.uploadMinimized,
      activeUploadType: uploadState.activeUploadType,
      processName: uploadState.processName,
      resultsUpload: uploadState.resultsUpload,
      errorsUpload: uploadState.errorsUpload,
      bajaFiles: uploadState.bajaFiles,
    };

    const shouldOpenModal =
      uploadState.activeUploadType &&
      (uploadState.restoreRequested || uploadState.showResultsRequested);

    if (shouldOpenModal) {
      if (uploadState.activeUploadType === 'records') {
        nextState.isModalUploadVisible = true;
      } else if (uploadState.activeUploadType === 'inactive') {
        nextState.isModalUploadInactiveVisible = true;
      } else if (uploadState.activeUploadType === 'related') {
        nextState.isModalUploadRelatedVisible = true;
      }
      nextState.uploadMinimized = false;
    }

    this.setState(nextState, () => {
      if (uploadState.restoreRequested) {
        UploadProgressManager.clearRestoreRequest();
      }
      if (uploadState.showResultsRequested) {
        UploadProgressManager.clearShowResultsRequest();
      }
    });
  };

  bindUploadProgressManager() {
    UploadProgressManager.setOnCompleteHook(() => {
      const { currentPage } = this.state;
      this.handlePaginationChange(currentPage);
    });

    if (this.uploadUnsubscribe) {
      this.uploadUnsubscribe();
    }

    this.uploadUnsubscribe = UploadProgressManager.subscribe(this.applyUploadState);
  }

  async componentDidMount() {
    const { currentUser, match } = this.props;

    // Suscribirse de inmediato para poder restaurar el modal al volver desde otra sección
    this.bindUploadProgressManager();

    let { filters } = this.state;
    if (match.params && match.params.params) {
      try {
        const p = JSON.parse(atob(match.params.params));
        filters = { ...filters, ...p };
      } catch (e) {
        console.error("Error al decodificar parametros:", e);
      }
    } else {
      const query = new URLSearchParams(this.props.location.search);
      const filterFecAlerta = query.get("fa");

      filters["estados"] = ["ACTIVE"];
      filters["filterFecAlerta"] = filterFecAlerta;
      filters["fecAlerta"] = filterFecAlerta;
    }

    const parametersClient = await getParamsPromise();
    const users = await getUsersByClientPromise();
    this.setState({
      filters,
      userAsig: currentUser.id,
      users,
      parametersClient,
    });
    if (
      currentUser.cliente.outsourcer &&
      currentUser.cliente.clientes !== null &&
      currentUser.cliente.clientes.length > 0 &&
      currentUser.subcliente !== null
    ) {
      this.setState({ subclienteId: currentUser.subcliente.id });
    }

    this.handleApplyFilters(filters);

    getAreasPromise().then(areas => {
      this.setState({ areasList: areas });
    });
  }

  async handleApplyFilters(_filters) {
    this.setState({ firstLoading: true });
    const { filters } = this.state;
    if (_filters) {
      Object.assign(filters, _filters);
    }

    const oldColors = JSON.parse(JSON.stringify(this.state.colors));
    getRiskCLClientesPromise(filters).then(risk => {
      const colors = this.renderColors(risk);
      let critical = 0;
      let high = 0;
      let medium = 0;
      let low = 0;
      let n = 0;
      let na = 0;

      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("BLACK")
      ) {
        critical = colors.black;
      }
      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("RED")
      ) {
        high = colors.red;
      }
      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("ORANGE")
      ) {
        medium = colors.orange;
      }
      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("YELLOW")
      ) {
        low = colors.yellow;
      }
      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("GREEN")
      ) {
        n = colors.green;
      }
      if (
        filters["risk"] === null ||
        filters["risk"] === undefined ||
        filters["risk"].length === 0 ||
        filters["risk"].includes("NA")
      ) {
        na = colors.na;
      }
      let total = critical + high + medium + low + n + na;
      let colorsCake = { total, critical, high, medium, low, n, na };

      this.setState({ colors, colorsCake, firstLoading: false });

      this.handleAnimateNumbers(
        "animated-number-black",
        oldColors.black,
        colors.black,
        650
      );
      this.handleAnimateNumbers(
        "animated-number-red",
        oldColors.red,
        colors.red,
        650
      );
      this.handleAnimateNumbers(
        "animated-number-yellow",
        oldColors.yellow,
        colors.yellow,
        650
      );
      this.handleAnimateNumbers(
        "animated-number-orange",
        oldColors.orange,
        colors.orange,
        650
      );
      this.handleAnimateNumbers(
        "animated-number-green",
        oldColors.green,
        colors.green,
        650
      );
      this.handleAnimateNumbers(
        "animated-number-grey",
        oldColors.na,
        colors.na,
        650
      );
    })

    getFiltersCLClientesPromise(filters).then(filter => {
      filters["filterFalsosPositivos"] = filter.pendingReview;
      this.setState({
        filters,
        groups: filter.groups,
        categories: filter.categories,
        areas: filter.areas,
      });

    })

    this.handlePaginationChange(1);
  }

  async handlePaginationChange(currentPage) {
    const { resultsPerPage } = this.state;
    const fromNum = (currentPage - 1) * resultsPerPage;
    this.setState({ isLoading: true, fromNum });

    const { filters, chkAll, isSendAll } = this.state;

    const clients = await getClientsPromise(fromNum, resultsPerPage, filters);

    this.setState({
      isLoading: false,
      clients: clients.records,
      currentPage: currentPage,
      resultsTotalNum: clients.total,
      totalCurrentUser: clients.total,
    });

    if(chkAll && !isSendAll) {
      this.setState({
        chkAll: false
      })
    }
  }

  async handleChangeFilters(
    filterName,
    filterOption,
    filterValue,
    search = true
  ) {
    const { filters } = this.state;
    const { currentUser } = this.props;

    if (
      filterName === "text" ||
      filterName === "fromDate" ||
      filterName === "toDate" ||
      filterName === "fromDateRisk" ||
      filterName === "toDateRisk" ||
      filterName === "fecAlerta" ||
      filterName === "falsosPositivos" ||
      filterName === "falsosPositivosPendientes" ||
      filterName === "subclienteId" ||
      filterName === "complianceFilter"
    ) {
      if (filterValue) {
        filters[filterName] = filterOption;
      } else {
        filters[filterName] = null;
      }
    } else {
      let filterValues = filters[filterName];
      if (filterValues === null || filterValues === undefined)
        filterValues = [];

      if (filterValue) {
        if (!filterValues.includes(filterOption)) {
          filterValues.push(filterOption);
        }
      } else if (filterValues.includes(filterOption)) {
        let index = filterValues.indexOf(filterOption);

        filterValues.splice(index, 1);
      }
      filters[filterName] = filterValues;
    }

    await this.setState({ filters });

    if (search) {
      await this.handleApplyFilters();

      if (
        currentUser.cliente.abreviado !== "demostraciones" &&
        currentUser.cliente.abreviado !== "demo"
      ) {
        await ga.saveRiskChanges(filterName, filterOption, filterValue);
        await ga.saveLeftFiltersChanges(filterName, filterOption, filterValue);
      }
    }
  }

  getBreadcrumbs() {
    const { t } = this.props;

    const breadcrumbs = [
      {
        title: t("messages.aml.register"),
        icon: "user-add",
        link: "/registro",
      },
    ];

    return breadcrumbs;
  }

  renderColors(filters) {
    const colors = {
      black: 0,
      red: 0,
      yellow: 0,
      orange: 0,
      green: 0,
      na: 0,
      total: 0,
    };

    if (filters.BLACK) {
      colors.black = filters.BLACK;
    }

    if (filters.RED) {
      colors.red = filters.RED;
    }

    if (filters.ORANGE) {
      colors.orange = filters.ORANGE;
    }

    if (filters.YELLOW) {
      colors.yellow = filters.YELLOW;
    }

    if (filters.GREEN) {
      colors.green = filters.GREEN;
    }

    if (filters.NA) {
      colors.na = filters.NA;
    }
    colors.total =
      colors.black +
      colors.red +
      colors.orange +
      colors.yellow +
      colors.green +
      colors.na;
    return colors;
  }

  handleNewProfile = () => {
    this.setState({ itemTable: {} });
  };

  handleOnCancelModalUbos() {
    this.setState({ isModalUbosVisible: false });
    //const { currentPage } = this.state
    //this.handlePaginationChange(currentPage)
  }

  handleViewUbos = (record) => {
    this.setState({ isModalUbosVisible: true, selectedRecord: record });
  };

  handleOnCancelModalRisk() {
    this.setState({ isModalRiskVisible: false });
  }

  handleModalRisk(record) {
    this.setState({ isModalRiskVisible: true, selectedRecord: record });
  }

  handleUploadBatch = () => {
    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }
    this.setState({ isModalUploadVisible: true, uploaded: false });
  };

  handleUploadBatchInactive = () => {
    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }
    this.setState({ isModalUploadInactiveVisible: true, uploaded: false });
  };

  handleUploadRelated = () => {
    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }
    this.setState({ isModalUploadRelatedVisible: true, uploaded: false });
  };

  isUploadInProgress() {
    return UploadProgressManager.isInProgress();
  }

  notifyUploadInProgress() {
    const { t } = this.props;
    notification.warning({
      message: t('messages.aml.warning'),
      description: t('messages.aml.uploadInProgress'),
    });
  }

  minimizeUploadModal() {
    this.setState({
      isModalUploadVisible: false,
      isModalUploadInactiveVisible: false,
      isModalUploadRelatedVisible: false,
    });
    UploadProgressManager.minimize();
  }

  handleModalUploadClose() {
    if (this.state.uploading && !this.state.uploaded) {
      this.minimizeUploadModal();
      return;
    }
    this.closeUploadModal();
  }

  closeUploadModal() {
    UploadProgressManager.reset();
    this.setState({
      isModalUploadVisible: false,
      isModalUploadInactiveVisible: false,
      isModalUploadRelatedVisible: false,
      uploading: false,
      uploaded: false,
      uploadProcessed: 0,
      uploadTotal: 0,
      uploadProgress: 0,
      uploadMinimized: false,
      activeUploadType: null,
      processName: null,
      fileList: [],
      resultsUpload: [],
      bajaFiles: null,
    });
  }

  handleCancelUploadProcess = () => {
    const { t } = this.props;

    Modal.confirm({
      title: t('messages.aml.confirmCancelUpload'),
      content: t('messages.aml.confirmCancelUploadDescription'),
      okText: t('messages.aml.cancelUploadProcess'),
      okType: 'danger',
      cancelText: t('messages.aml.cancel'),
      onOk: () => {
        this.closeUploadModal();
      },
    });
  };

  renderUploadModalFooter(onSave, templateContent) {
    const { t } = this.props;
    const { uploading, uploaded } = this.state;

    if (uploaded) {
      return (
        <Button onClick={() => this.closeUploadModal()}>
          {t('messages.aml.btnClose')}
        </Button>
      );
    }

    if (uploading) {
      return (
        <Button type="danger" onClick={this.handleCancelUploadProcess}>
          {t('messages.aml.cancelUploadProcess')}
        </Button>
      );
    }

    return (
      <>
        {templateContent}
        <Button onClick={() => this.closeUploadModal()}>
          {t('messages.aml.cancel')}
        </Button>
        <Button type="primary" onClick={onSave}>
          {t('messages.aml.save')}
        </Button>
      </>
    );
  }

  handleSelectAll = () => {
    if(this.state.isSendAll) {
      this.handleSelectDeselectAll(false)
    }
    this.setState((prevState) => ({
      isSendAll: !prevState.isSendAll,
    }));
  };

  getProcessNameLabel(processName) {
    const { t } = this.props;

    if (processName === 'readFile') {
      return t("messages.aml.readingFile");
    }
    if (processName === 'saveRecords') {
      return t("messages.aml.saveRecords");
    }
    if (processName === 'validateFile') {
      return t("messages.aml.processingFile");
    }
    if (processName === 'finished') {
      return t("messages.aml.finished");
    }

    return processName;
  }

  renderUploadProgressContent() {
    const { t } = this.props;
    const { uploadProgress, uploadProcessed, uploadTotal, processName } = this.state;

    return (
      <div>
        {processName && (
          <h3>{this.getProcessNameLabel(processName)}</h3>
        )}
        {uploadTotal > 0 && (
          <p>
            {t("messages.aml.uploadProcessingRecords", {
              processed: formatNumberHelper(uploadProcessed),
              total: formatNumberHelper(uploadTotal),
            })}
          </p>
        )}
        <p>
          {t("messages.aml.uploadLoadedPercent", { percent: uploadProgress })}
        </p>
        <Progress
          type="line"
          percent={uploadProgress}
          style={{ padding: '20px 0px' }}
        />
      </div>
    );
  }

  listenProgress = (batchId, uploadType) => {
    UploadProgressManager.listen(batchId, uploadType);
  };

  handleUploadClient = () => {
    const {
      fileList,
      userAsig,
      subclienteId,
      category,
      grupo,
      parametersClient,
    } = this.state;
    const { t } = this.props;

    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }

    if (userAsig === null) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectAUser"),
      });
      return;
    }
    if (category === null) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectACategory"),
      });
      return;
    }

    if (parametersClient.gruposNames && parametersClient.gruposNames.length > 1 && grupo.length === 0) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectAGroup"),
      });
      return;
    }
    if (fileList.length === 0) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectAFile"),
      });
      return;
    }
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });
    formData.append("userAsigned", userAsig);
    formData.append("category", category);
    if (grupo && grupo.length > 0) {
      formData.append("grupo", grupo.join(","));
    }
    if (subclienteId !== null) {
      formData.append("subclienteId", subclienteId);
    }
    formData.append("processUF", this.state.processUF);
    formData.append("formularioInterno", this.state.formularioInterno);

    UploadProgressManager.start('records');

    uploadClientsPromise(formData).then((results) => {
      if (results.status === "OK") {
        const batchId = results.batchId;

        this.listenProgress(batchId, 'records');
      } else {
        UploadProgressManager.reset();
        notification.error({
          message: t('messages.aml.error'),
          description: results.message,
        });
      }
    });
  };

  fileValidation = (file) => {
    const { t } = this.props;
    const ext = file.name.split('.').pop().toLowerCase();
      if (ext !== 'xlsx' && ext !== 'txt' && ext !== 'csv') {
      notification.error({
        message: t('messages.aml.error'),
        description: t('messages.aml.format.Not.Allowed', { 0: '.xlsx, .txt, .csv' }),
      });
      return false;
    }
    if (file.size > 150 * 1024 * 1024) {
      notification.error({
        message: t('messages.aml.fileExceedsSize'),
        description: t('messages.aml.fileSizeDescription', {
          fileSize: (file.size / (1024 * 1024)).toFixed(2),
          maxSize: 150,
        }),
      });
      return false;
    }
    return true;
  };

  handleUploadRelatedFile = () => {
    const {
      fileList,
    } = this.state;
    const { t } = this.props;

    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }

    if (fileList.length === 0) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectAFile"),
      });
      return;
    }

    if (!this.fileValidation(fileList[0])) {
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    UploadProgressManager.start('related');

    uploadRelatedPromise(formData).then((results) => {
      const batchId = results.batchId;

      this.listenProgress(batchId, 'related');
    });
  };

  handleUploadClientInactive = () => {
    const {
      fileList,
    } = this.state;
    const { t } = this.props;

    if (this.isUploadInProgress()) {
      this.notifyUploadInProgress();
      return;
    }

    if (fileList.length === 0) {
      notification.error({
        message: t('messages.aml.error'),
        description: t("messages.aml.youMustSelectAFile"),
      });
      return;
    }

    if (!this.fileValidation(fileList[0])) {
      return;
    }

    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("file", file);
    });

    UploadProgressManager.start('inactive');

    bajaClientesPromise(formData).then((results) => {
      if (results.status === "OK") {
        const batchId = results.batchId;

        this.listenProgress(batchId, 'inactive');
      } else {
        this.setState({
          errorsUpload: results.errors,
        });
        UploadProgressManager.reset();
        notification.error({
          message: t('messages.aml.error'),
          description: results.message,
        });
      }
    });
  };

  handleOnChangeSendMail = (sendMail) => {
    this.setState({ formularioInterno: !sendMail });
  };

  handleOnChangeUF = (processUF) => {
    this.setState({ processUF });
    if (!processUF) {
      this.setState({ formularioInterno: true });
    }
  };

  handleOnChangeGrupo = (grupo) => {
    this.setState({ grupo: grupo });
  };

  getUsersAsig(users) {
    const { currentUser } = this.props;
    let _users = [];
    for (let i = 0; i < users.length; i++) {
      if (
        (users[i].type === "ADMIN" ||
          users[i].type === "SADMIN" ||
          users[i].type === "USUARIO") &&
        ((currentUser.cliente.oficialCto !== null &&
          currentUser.cliente.oficialCto.id === users[i].id) ||
          (users[i].modules !== null && users[i].modules.includes("REGISTRO")))
      ) {
        _users.push(
          <Select.Option value={users[i].id}>{users[i].name}</Select.Option>
        );
      }
    }
    return _users;
  }

  handleReport() {
    this.setState({ isModalReportVisible: true });
  }

  handleOnCancelModalReport() {
    this.setState({ isModalReportVisible: false });
  }

  async handleExcelReport() {
    this.setState({ isLoadingExport: true });
    this.localGenerateReport("RECORDS").then((r) => {
      if (r) this.setState({ isLoadingExport: true });
    });
  }

  async handleRiskReport() {
    this.localGenerateReport("RISK").then((r) => {
      if (r) this.setState({ isLoadingRisk: true });
    });
  }

  finishReport() {
    this.setState({
      isLoadingExport: false,
      isLoadingMp: false,
      isLoadingBfReport: false,
      isLoadingRisk: false,
      isLoadingCertificates: false,
      isLoadingFormReport: false,
      isLoadingC57DeclReport: false,
    });
  }

  async handlePDFReport() {
    this.localGenerateReport("PDFS").then((r) => {
      if (r) this.setState({ isLoadingCertificates: true });
    });
  }

  async handleBFReport() {
    this.localGenerateReport("UBOS").then((r) => {
      if (r) this.setState({ isLoadingBfReport: true });
    });
  }

  async handleMallasPropiedadReport() {
    this.localGenerateReport("MALLAS").then((r) => {
      if (r) this.setState({ isLoadingMp: true });
    });
  }

  async handleFormsReport() {
    this.localGenerateReport("FORMS").then((r) => {
      if (r) this.setState({ isLoadingFormReport: true });
    });
  }

  handleC57DeclarationsExport() {
    const { selectedItems, isSendAll, filterCurrentUser } = this.state;
    const { generateReport } = this.context;
    const { t } = this.props;
    let params;
    if (isSendAll) {
      params = { ...filterCurrentUser, isSendAll: true, estado: "ACTIVE", types: ["Entity"] };
    } else {
      const ids = selectedItems.filter((item) => item.type === "Entity").map((item) => item.id);
      if (ids.length === 0) {
        notification.warning({
          message: t("messages.aml.warning"),
          description: t("messages.aml.register.actions.exportC57DeclNoEntity"),
        });
        return;
      }
      params = { ids };
    }
    this.setState({ isLoadingC57DeclReport: true });
    generateReport("C57_DECL", params, this.finishReport.bind(this)).then((r) => {
      if (!r) this.setState({ isLoadingC57DeclReport: false });
    });
  }

  handleAnimateNumbers(id, start, end, duration) {
    // assumes integer values for start and end
    var obj = document.getElementById(id);
    var range = end - start;
    // no timer shorter than 50ms (not really visible any way)
    var minTimer = 50;
    // calc step time to show all interediate values
    var stepTime = Math.abs(Math.floor(duration / range));

    // never go below minTimer
    stepTime = Math.max(stepTime, minTimer);

    // get current time and calculate desired end time
    var startTime = new Date().getTime();
    var endTime = startTime + duration;
    var timer;

    function run() {
      if (obj) {
        var now = new Date().getTime();
        var remaining = Math.max((endTime - now) / duration, 0);
        var value = Math.round(end - remaining * range);
        obj.innerHTML = value;
        if (value === end) {
          clearInterval(timer);
        }
      }

      timer = setInterval(run, stepTime);
      run();
    }
  }

  handleOnChangeAsignedUser(user) {
    this.setState({ userAsig: user });
  }

  handleOnChangeCategory(category) {
    this.setState({ category });
  }

  handleOnChangeSubcliente(subclienteId) {
    this.setState({ subclienteId });
  }

  downloadPlantilla(type) {
    if (type === "records") {
      window.open(apiConfig.url + "/../templates/carga_registro.xlsx");
    } else if (type === "related") {
      window.open(
        apiConfig.url + "/../templates/carga_registro_relacionados.xlsx"
      );
    } else if (type === "massiveDownload") {
      window.open(apiConfig.url + "/../templates/baja_masiva.xlsx");
    }
  }

  downloadErrors() {
    const { errorsUpload } = this.state;
    ReportService.read(
      "/inputFile",
      { path: "records/" + errorsUpload },
      null,
      "reporte.xlsx"
    );
  }

  downloadBajaFile(fileName) {
    const { bajaFiles } = this.state;
    const { t } = this.props;
    if (bajaFiles) {
      ReportService.read(
        "/inputFile",
        { path: bajaFiles, remove: true },
        null,
        fileName,
        null,
        t
      );
    }
  }

  registerRowShowsCheckbox(record) {
    return (
      record.status === "ACTIVE" &&
      (record.type === "Entity" || this.hasServices(record))
    );
  }

  hasServices(record) {
    const { currentUser } = this.props;
    const { parametersClient } = this.state;
    return (
      record.status === "ACTIVE" &&
      (currentUser.cliente.modules.includes("ONBOARDING") ||
        (currentUser.cliente.modules.includes("QUIEBRA") &&
          !record.hasQuiebras) ||
        (record.type === "Entity" &&
          currentUser.cliente.modules.includes("ADMCLI") &&
          (currentUser.cliente.modules.includes("REG-ENTITY") ||
            (!currentUser.cliente.modules.includes("REG-ENTITY") &&
              !currentUser.cliente.modules.includes("REG-PERSON"))) &&
          parametersClient &&
          parametersClient.ubofinder &&
          ((!parametersClient.ubofinder.noInvestigaMalla && !record.processUF) ||
            (!parametersClient.ubofinder.sinFormulario &&
              (!parametersClient.ubofinder.formularioInterno ||
                !record.formularioInterno)))) ||
        (currentUser.cliente.modules.includes("CDI-FORM") &&
          ((currentUser.cliente.modules.includes("CDI-FORM-CDI") &&
            currentUser.modules.includes("CDI-FORM-GD-P") &&
            record.category === "PROVEEDOR") ||
            ((currentUser.cliente.modules.includes("CDI-FORM-CDI") ||
              currentUser.cliente.modules.includes("CDI-FORM-REL")) &&
              (currentUser.modules.includes("CDI-FORM-GD-T") ||
                currentUser.modules.includes("CDI-FORM-GD")) &&
              record.category === "COLABORADOR") ||
            (currentUser.cliente.modules.includes("CDI-FORM-DIR") &&
              currentUser.modules.includes("CDI-FORM-GDIR") &&
              record.category === "DIRECTOR") ||
            (currentUser.cliente.modules.includes("CDI-FORM-PATR") &&
              currentUser.modules.includes("CDI-FORM-GPATR") &&
              record.category === "CLIENTE") ||
            (currentUser.cliente.modules.includes("FORM-ODF") &&
              currentUser.modules.includes("FORM-ODF")))))
    );
  }

  handleSelectDeselectAll(checked) {
    const { filters, clients, resultsTotalNum } = this.state;
    this.setState({ chkAll: checked });
    if (!checked) {
      this.setState({
        selectedItems: [],
        filterCurrentUser: null,
        totalCurrentUser: 0,
        isSendAll: false,
      });
    } else {
      const itemsPerPage = clients
        .filter((i) => this.registerRowShowsCheckbox(i))
        .map((i) => ({
          id: i.id,
          name: i.nombre,
          category: i.category,
          type: i.type,
          status: i.status,
        }));
      this.setState({
        selectedItems: itemsPerPage,
        filterCurrentUser: filters,
        totalCurrentUser: resultsTotalNum,
        isSendAll: false,
      });
    }
  };

  render() {
    const amountOfRegister = 2;
    const { t, currentUser, i18n } = this.props;
    const {
      breadcrumbs,
      clients,
      currentPage,
      firstLoading,
      resultsPerPage,
      resultsTotalNum,
      colors,
      colorsCake,
      isLoading,
      filters,
      groups,
      areas,
      areasList,
      categories,
      isModalRiskVisible,
      selectedRecord,
      isModalUbosVisible,
      isModalUploadVisible,
      isModalUploadInactiveVisible,
      isModalUploadRelatedVisible,
      fileList,
      processUF,
      formularioInterno,
      resultsUpload,
      uploaded,
      uploadProgress,
      processName,
      uploading,
      userAsig,
      users,
      parametersClient,
      isModalReportVisible,
      bajaFiles,
      isLoadingExport,
      isLoadingRisk,
      isLoadingCertificates,
      isLoadingBfReport,
      isLoadingMp,
      isLoadingFormReport,
      isLoadingC57DeclReport,
      selectedItems,
      chkAll,
      isAdvancedSearchVisible,
      recordsAction,
      filterCurrentUser,
      totalCurrentUser,
      isSendAll,
      actionType,
      itemTable,
    } = this.state;

    const hasMultiplePages =
      typeof resultsTotalNum === "number" &&
      typeof resultsPerPage === "number" &&
      resultsTotalNum > resultsPerPage;

    const propsUpload = {
      accept: ".xlsx, .txt, .csv",
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        const ext = file.name.split('.').pop().toLowerCase();
          if (ext !== 'xlsx' && ext !== 'txt' && ext !== 'csv') {
              notification.error({
                message: t('messages.aml.error'),
                description: t('messages.aml.format.Not.Allowed', { 0: '.xlsx, .txt, .csv' }),
              });
              return false;
            }
            if (file.size > 150 * 1024 * 1024) {
              notification.error({
                message: t('messages.aml.fileExceedsSize'),
                description: t('messages.aml.fileSizeDescription', {
                  fileSize: (file.size / (1024 * 1024)).toFixed(2),
                  maxSize: 150,
                }),
              });
              return false;
            }
            if (this.state.fileList.length === 0) {
              this.setState((state) => ({
                fileList: [ ...state.fileList, file ],
              }));
            }
            return false;
          },
          multiple: false,
          fileList,
        };

    const propsUploadExcelTxt = {
          accept: ".xlsx,.txt",
          onRemove: (file) => {
              this.setState((state) => {
                  const index = state.fileList.indexOf(file);
                  const newFileList = state.fileList.slice();
                  newFileList.splice(index, 1);
                  return {
                      fileList: newFileList,
                  };
              });
          },
          beforeUpload: (file) => {
              const ext = file.name.split('.').pop().toLowerCase();
              if (ext !== 'xlsx' && ext !== 'txt') {
                  notification.error({
                      message: t('messages.aml.error'),
                      description: t('messages.aml.format.Not.Allowed', { 0: '.xlsx, .txt' }),
                  });
                  return false;
              }
              if (file.size > (150 * 1024 * 1024)) {
                  notification.error({
                      message: t('messages.aml.fileExceedsSize'),
                      description: t('messages.aml.fileSizeDescription', {
                          fileSize: (file.size / (1024 * 1024)).toFixed(2),
                          maxSize: 150,
                      }),
                  });
                  return false;
              }
              if (this.state.fileList.length === 0) {
                  this.setState((state) => ({
                      fileList: [...state.fileList, file],
                  }));
              }
              return false;
          },
          multiple: false,
          fileList,
      };

    const actionTypeRender = {
      cronForm: [
        <Icon type="clock-circle" />,
        " ",
        t("messages.aml.register.actions.cronFormOnb"),
      ],
      cronCdiForm: [
        <Icon type="clock-circle" />,
        " ",
        t("messages.aml.register.actions.cronFormCdi"),
      ],
      newRequest: [
        <Icon type="mail" />,
        " ",
        t("messages.aml.register.actions.sendOnb"),
      ],
      newCdiRequest: [<Icon type="mail" />, " ", t("messages.aml.sendMail")],
      brokeRegister: [
        <Icon type="clock-circle" />,
        " ",
        t("messages.aml.register.actions.activateBankruptcyRegistration"),
      ],
      uboFinder: [<Icon type="clock-circle" />, " ", t("messages.aml.ubosInvestigate")],
      beneficiariesMatchs: [<Icon type="search" />, " ", t("messages.aml.findFinalBeneficiariesMatchs")],
      form57: [
        <Icon type="clock-circle" />,
        " ",
        t("messages.aml.solicitud.formc57"),
      ],
    };

    const renderType = (type) => {
      if (type === "Person") {
        return personIcon;
      } else if (type === "Entity") {
        return entityIcon;
      }
    };

    const cbFilters = (objFilters) => {
      const { filters } = this.state;
      filters.advanced = objFilters;
      this.setState({ filters });
      this.handleApplyFilters();
    };

    const getTableColumns = () => {
      const { currentUser } = this.props;
      const { resultsTotalNum } = this.state;
      let columns = [
        {
          title: () => (
            <div>
              <Checkbox disabled={resultsTotalNum < 1} onChange={(e) => this.handleSelectDeselectAll(e.target.checked)} checked={chkAll} />
            </div>
          ),
          width: "5%",
          align: "center",
          render: (record) => {
            return (
              this.registerRowShowsCheckbox(record) && (
                <Checkbox
                  checked={
                    selectedItems.filter((i) => i.id === record.id).length > 0 ||
                    chkAll
                  }
                  onChange={(e) => {
                    this.setState({ chkAll: false });
                    let checkedItem = [...selectedItems];
                    if (e.target.checked) {
                      checkedItem.push({
                        id: record.id,
                        name: record.nombre,
                        category: record.category,
                        type: record.type,
                        status: record.status,
                      });
                    } else {
                      checkedItem = checkedItem.filter(
                        (i) => i.id !== record.id
                      );
                    }
                    this.setState({
                      selectedItems: checkedItem,
                      totalCurrentUser: checkedItem.length,
                    });
                  }}
                />
              )
            );
          },
        },
        {
          title: t('messages.aml.type'),
          className: "text-center-type-onb",
          width: "5%",
          render: (item) => {
            return (
              <Row>
                <Col span={24} style={{ textAlign: "center", fontSize: "5px" }}>
                  <img src={renderType(item.type)} alt="" width="40" />
                </Col>
              </Row>
            );
          },
          // sorter: (a, b) => a.creationDate - b.creationDate,
        },
        {
          title: t("messages.aml.register.table.titles.nombrerut"),
          width: "24%",
          render: (record) => {
            return (
              <>
                <div className="name-col-table">
                  <Button
                    type="link"
                    onClick={() => this.setState({ itemTable: record })}
                  >
                    {record.nombre}
                  </Button>
                  <Button
                    type="link"
                    onClick={() => this.setState({ itemTable: record })}
                  >
                    {record.rut}
                  </Button>
                </div>
              </>
            );
          },
        },
        {
          title: (
            <>
              <div>{t("messages.aml.register.table.titles.lastUpdate")}</div>
              {currentUser.cliente.modules.includes("ONBOARDING") && (
                <div>OnBoarding</div>
              )}
            </>
          ),
          width: "9%",
          align: "center",
          dataIndex: "fecLastUpdate",
          render: (text, record) => (
            <>
              { text && <div>{moment(text).format("DD/MM/YYYY")}</div> }
              {currentUser.cliente.modules.includes("ONBOARDING") &&
                record.ficha && (
                  <div>
                    {record.ficha.declDate
                      ? moment(record.ficha.declDate).format("DD/MM/YYYY")
                      : t("messages.aml.notUpdated")}
                  </div>
                )}
            </>
          ),
        },
        {
          title: t("messages.aml.compliance"),
          className: "column-cumplimiento",
          section: "risk-compliance",
          children: [
            {
              title: t("messages.aml.pepAndSanctions"),
              key: Math.random(),
              dataIndex: "compliance",
              width: "9%",
              align: "center",
              render: (text) => {
                return currentUser.cliente.modules.includes("MONITOR-AML") &&
                  currentUser.cliente.modules.includes("PEPSAN") ? (
                  <div className="item-risk-align">
                    <div
                      className={
                        "child-risk-onb-circle risk-" +
                        (text && text.PEPSAN && text.PEPSAN.color
                          ? text.PEPSAN.color
                          : "GRAY")
                      }
                    >
                      {text && text.PEPSAN && text.PEPSAN.bases
                        ? text.PEPSAN.bases.length
                        : "n/a"}
                    </div>
                  </div>
                ) : (
                  <div className="item-risk-align">
                    <div className="child-risk-onb-circle risk-GRAY">
                      <Icon type="lock" />
                    </div>
                  </div>
                );
              },
            },
            {
              title: "KYC",
              key: Math.random(),
              dataIndex: "compliance",
              width: "5%",
              align: "center",
              render: (text) => {
                return currentUser.cliente.modules.includes("MONITOR-AML") &&
                  currentUser.cliente.modules.includes("KYCAME") ? (
                  <div className="item-risk-align">
                    <div
                      className={
                        "child-risk-onb-circle risk-" +
                        (text && text.KYCAME && text.KYCAME.color
                          ? text.KYCAME.color
                          : "GRAY")
                      }
                    >
                      {text && text.KYCAME && text.KYCAME.bases
                        ? text.KYCAME.bases.length
                        : "n/a"}
                    </div>
                  </div>
                ) : (
                  <div className="item-risk-align">
                    <div className="child-risk-onb-circle risk-GRAY">
                      <Icon type="lock" />
                    </div>
                  </div>
                );
              },
            },
            {
              title: () => {return (<> <div> UBO & </div> Companies</>)},
              key: Math.random(),
              dataIndex: "compliance",
              width: "12%",
              align: "center",
              render: (text, record) => {
                return (
                  <Row>
                    <Col span={8}>
                      {currentUser.cliente.modules.includes("MONITOR-AML") &&
                      currentUser.cliente.modules.includes("UBOCOM") ? (
                        <div
                          className={
                            "child-risk-onb-circle risk-" +
                            (text && text.UBOCOM && text.UBOCOM.color
                              ? text.UBOCOM.color
                              : "GRAY")
                          }
                        >
                          {text && text.UBOCOM && text.UBOCOM.bases
                            ? text.UBOCOM.bases.length
                            : "n/a"}
                        </div>
                      ) : (
                        <div className="child-risk-onb-circle risk-GRAY">
                          <Icon type="lock" />
                        </div>
                      )}
                    </Col>
                    {record.type === "Entity" &&
                      currentUser.cliente.modules.includes("ADMCLI") &&
                      parametersClient &&
                      parametersClient.ubofinder &&
                      ((record.processUF &&
                        !parametersClient.ubofinder.noInvestigaMalla) ||
                        (!record.formularioInterno &&
                          !parametersClient.ubofinder.sinFormulario)) && (
                        <Col span={8}>
                          <div style={{ cursor: "pointer" }}>
                            <Tooltip title={t("messages.aml.viewFinalBeneficiaries")}>
                              <Icon
                                type="team"
                                style={{ fontSize: "20px" }}
                                onClick={() => {
                                  this.handleViewUbos(record);
                                }}
                              />
                            </Tooltip>
                          </div>
                        </Col>
                      )}
                    {record.nroRelated !== null && (
                      <Col span={8}>
                        <Tooltip title={t("messages.aml.relatedTooltip")}>
                          <div className="number-register-wrapper">
                            R {record.nroRelated}
                          </div>
                        </Tooltip>
                      </Col>
                    )}
                  </Row>
                );
              },
            }
          ],
        },
        {
          title: t("messages.aml.risk"),
          className: "onbRiskTitle",
          width: "9%",
          dataIndex: "risk",
          render: (text, record) => <div
                className={
                  "child-risk-onb risk-" + (text ?? "GRAY")
                }
                onClick={
                  record.origRisk ? () => this.handleModalRisk(record) : null
                }
                style={record.origRisk && { cursor: "pointer" }}
              >
                {text !== null ?
                  t("messages.aml.risk."+text)
                  : "N/A"
                }
              </div>

        },
        {
          title: () => <div className="image"></div>,
          className: "onbLogoTitle",
          width: "5%",
          render: (record) => {
            return (
              this.hasServices(record) && (
                <div className="ellipsis-icon-onb">
                  <Dropdown overlay={() => menu(record, "ellipsis")}>
                    <Icon
                      type="more"
                      style={{ fontSize: "30px", color: "#FE9F0C" }}
                    />
                  </Dropdown>
                </div>
              )
            );
          },
        },
      ];

      if(currentUser.type === 'AUDIT') {
        columns.shift();
        columns.pop();
      }

      const complianceSection = columns.find((column) => column.section === "risk-compliance")
      if(currentUser.cliente.modules.includes("ONBOARDING") && complianceSection) {
        complianceSection.children.push(
            {
              title: "OnBoarding",
              key: Math.random(),
              dataIndex: "compliance",
              width: "9%",
              align: "center",
              render: (text) => {
                return currentUser.cliente.modules.includes("ONBOARDING") ? (

                    <div className="item-risk-align">
                      <div
                          className={
                              "child-risk-onb-circle risk-" +
                              (text && text.ONB && text.ONB.color
                                  ? text.ONB.color
                                  : "GRAY")
                          }
                      >

                        {text && text.ONB && text.ONB.bases
                            ? text.ONB.bases.length
                            : "n/a"}
                      </div>
                    </div>
                ) : (
                    <div className="item-risk-align">
                      <div className="child-risk-onb-circle risk-GRAY">
                        <Icon type="lock"/>
                      </div>
                    </div>
                );
              },
            }
        )
      }

      return columns;
    };

    const menu = (record, menuType) => {
      if (menuType === "ellipsis") {
        return (
          <Menu>
            {currentUser.cliente.modules.includes("ONBOARDING") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "newRequest" });
                  handleAction(record);
                }}
              >
                <Icon type="mail" /> {t("messages.aml.register.actions.sendOnb")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("ONBOARDING") &&
              record.ficha && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "cronForm" });
                    handleAction(record);
                  }}
                >
                  <Icon type="clock-circle" /> {t("messages.aml.register.actions.cronFormOnb")}
                </Menu.Item>
              )}
            {currentUser.cliente.modules.includes("CDI-FORM") &&
              ((currentUser.cliente.modules.includes("CDI-FORM-CDI") && currentUser.modules.includes("CDI-FORM-GD-P")
                && record.category === "PROVEEDOR") ||
                ((currentUser.cliente.modules.includes("CDI-FORM-CDI") ||
                  currentUser.cliente.modules.includes("CDI-FORM-REL")) &&
                  (currentUser.modules.includes("CDI-FORM-GD-T") ||
                    currentUser.modules.includes("CDI-FORM-GD")) &&
                  record.category === "COLABORADOR") ||
                (currentUser.cliente.modules.includes("CDI-FORM-DIR") && currentUser.modules.includes("CDI-FORM-GDIR")
                  && record.category === "DIRECTOR") ||
                (currentUser.cliente.modules.includes("CDI-FORM-PATR") && currentUser.modules.includes("CDI-FORM-GPATR")
                  && record.category === "CLIENTE") ||
                (currentUser.cliente.modules.includes("FORM-PEP") && currentUser.modules.includes("FORM-PEP")) ||
                (currentUser.cliente.modules.includes("FORM-ODF") && currentUser.modules.includes("FORM-ODF"))
                ) && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "newCdiRequest" });
                    handleAction(record);
                  }}
                >
                  <Icon type="mail" /> {t("messages.aml.sendMail")}
                </Menu.Item>
              )}
            {currentUser.cliente.modules.includes("CDI-FORM") &&
              ((currentUser.cliente.modules.includes("CDI-FORM-CDI") &&
                currentUser.modules.includes("CDI-FORM-GD-P") &&
                record.category === "PROVEEDOR") ||
                ((currentUser.cliente.modules.includes("CDI-FORM-CDI") ||
                  currentUser.cliente.modules.includes("CDI-FORM-REL")) &&
                  (currentUser.modules.includes("CDI-FORM-GD-T") ||
                    currentUser.modules.includes("CDI-FORM-GD")) &&
                  record.category === "COLABORADOR") ||
                (currentUser.cliente.modules.includes("CDI-FORM-DIR") &&
                  currentUser.modules.includes("CDI-FORM-GDIR") &&
                  record.category === "DIRECTOR") ||
                (currentUser.cliente.modules.includes("CDI-FORM-PATR") &&
                  currentUser.modules.includes("CDI-FORM-GPATR") &&
                  record.category === "CLIENTE") ||
                (currentUser.cliente.modules.includes("FORM-PEP") && currentUser.modules.includes("FORM-PEP"))
                ) &&
              record.periodicities &&
              record.periodicities.find((p) => p.tipo !== "KYC") && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "cronCdiForm" });
                    handleAction(record);
                  }}
                >
                  <Icon type="clock-circle" /> {t("messages.aml.register.actions.cronFormCdi")}
                </Menu.Item>
              )}
            {currentUser.cliente.modules.includes("QUIEBRA") &&
              record &&
              !record.hasQuiebras && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "brokeRegister" });
                    handleAction(record);
                  }}
                >
                  <Icon type="fall" /> {t("messages.aml.register.actions.activateBankruptcyRegistration")}
                </Menu.Item>
              )}
            {record &&
              record.type === "Entity" &&
              currentUser.cliente.modules.includes("ADMCLI") &&
              (currentUser.cliente.modules.includes("REG-ENTITY") ||
                (!currentUser.cliente.modules.includes("REG-ENTITY") &&
                  !currentUser.cliente.modules.includes("REG-PERSON"))) &&
              parametersClient && parametersClient.ubofinder &&
              !parametersClient.ubofinder.noInvestigaMalla &&
              record.processUF === false && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "uboFinder" });
                    handleAction(record);
                  }}
                >
                  <Icon type="user" /> {t("messages.aml.ubosInvestigate")}
                </Menu.Item>
              )}
            {record &&
              record.type === "Entity" &&
              currentUser.cliente.modules.includes("ADMCLI") &&
              (currentUser.cliente.modules.includes("REG-ENTITY") ||
                (!currentUser.cliente.modules.includes("REG-ENTITY") &&
                  !currentUser.cliente.modules.includes("REG-PERSON"))) &&
              parametersClient && parametersClient.ubofinder &&
              !parametersClient.ubofinder.sinFormulario &&
              (!parametersClient.ubofinder.formularioInterno || !record.formularioInterno) &&
              (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "form57" });
                    handleAction(record);
                  }}
                >
                  <Icon type="mail" theme="filled" />{" "}
                  {t("messages.aml.solicitud.formc57")}
                </Menu.Item>
              )}
          </Menu>
        );
      } else if (menuType === "action") {
        return (
          <Menu>
            {currentUser.cliente.modules.includes("ONBOARDING") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "newRequest" });
                  handleAction(selectedItems);
                }}
              >
                <Icon type="mail" /> {t("messages.aml.register.actions.sendOnb")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("ONBOARDING") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "cronForm" });
                  handleAction(selectedItems);
                }}
              >
                <Icon type="clock-circle" /> {t("messages.aml.register.actions.cronFormOnb")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("CDI-FORM") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "newCdiRequest" });
                  handleAction(selectedItems);
                }}
              >
                <Icon type="mail" /> {t("messages.aml.sendMail")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("CDI-FORM") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "cronCdiForm" });
                  handleAction(selectedItems);
                }}
              >
                <Icon type="clock-circle" /> {t("messages.aml.register.actions.cronFormCdi")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("QUIEBRA") && (
              <Menu.Item
                onClick={() => {
                  this.setState({ actionType: "brokeRegister" });
                  handleAction(selectedItems);
                }}
              >
                <Icon type="fall" /> {t("messages.aml.register.actions.activateBankruptcyRegistration")}
              </Menu.Item>
            )}
            {currentUser.cliente.modules.includes("ADMCLI") &&
              parametersClient &&
              parametersClient.ubofinder &&
              !parametersClient.ubofinder.noInvestigaMalla && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "uboFinder" });
                    handleAction(selectedItems);
                  }}
                >
                  <Icon type="user" />
                  {t("messages.aml.ubosInvestigate")}
                </Menu.Item>
              )}
            {currentUser.cliente.modules.includes("ADMCLI") &&
              parametersClient &&
              parametersClient.ubofinder &&
              !parametersClient.ubofinder.sinFormulario && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "form57" });
                    handleAction(selectedItems);
                  }}
                >
                  <Icon type="mail" theme="filled" />
                  {t("messages.aml.solicitud.formc57")}
                </Menu.Item>
              )}
            {currentUser.cliente.modules.includes("ADMCLI") &&
              parametersClient &&
              parametersClient.ubofinder &&
              !parametersClient.ubofinder.sinFormulario && (
                <Menu.Item
                  onClick={() => this.handleC57DeclarationsExport()}
                  disabled={isLoadingC57DeclReport}
                >
                  <Icon type={isLoadingC57DeclReport ? "loading" : "file-excel"} />
                  {t("messages.aml.register.actions.exportC57Decl")}
                </Menu.Item>
              )}
            {selectedItems.length === amountOfRegister &&
              selectedItems.filter((item) => item.type === 'Entity').length === amountOfRegister && (
                <Menu.Item
                  onClick={() => {
                    this.setState({ actionType: "beneficiariesMatchs" });
                    handleAction(selectedItems);
                  }}
                >
                  <Icon type="search" />
                  {t("messages.aml.findFinalBeneficiariesMatchs")}
                </Menu.Item>
              )}
          </Menu>
        );
      }
    };

    //TODO: REVISAR CONDICION ELSE IF NO APLICA AHORA
    const handleAction = (recipients) => {
      if (Array.isArray(recipients)) {
        this.setState({recordsAction: selectedItems});
      } else if (recipients) {
        const recordObj = {
          id: recipients.id,
          name: recipients.nombre,
          category: recipients.category,
          type: recipients.type,
          status: recipients.status,
        };
        this.setState({ recordsAction: [recordObj] });
      }
    };

    const handleCancel = () => {
      this.handlePaginationChange(currentPage, filters);
      this.setState({
        recordsAction: [],
        selectedItems: [],
        chkAll: false,
        itemTable: null,
        selectedMode: "",
        isSendAll: false,
      });
    };

    const getUrlPerson = (id) => {
      return "/getImageClientUser/0/" + id;
      //<img src={ apiConfig.url + '/../getImageClientUser/0/' + item.id } alt="" style={{ height: '15px' }} />
    };

    return (
      <div className="register register-new">
        <PageTopBar breadcrumbs={breadcrumbs} />
        <Page>
          <PageHeader
            title={t("messages.aml.register")}
            description={t("messages.aml.registerDescription")}
            icon="user-add"
          >
            <div className="btn-actions">
              <div className="top-register-buttons">
                {currentUser.type !== "AUDIT" && 
                <>
                  <Button
                    type="primary"
                    onClick={this.handleNewProfile.bind(this)}
                    icon="plus"
                  >
                    {t("messages.aml.individualRegister")}
                  </Button>
                  <Button
                    type="primary"
                    onClick={this.handleUploadBatch.bind(this)}
                    icon="plus"
                  >
                    {t("messages.aml.entityUpload")}
                  </Button>
                    <Button
                        type="primary"
                        onClick={this.handleUploadBatchInactive.bind(this)}
                        icon="pause"
                    >
                        {t("messages.aml.entityUploadInactivate")}
                  </Button>
                  <Button
                    type="primary"
                    onClick={this.handleUploadRelated.bind(this)}
                    icon="upload"
                  >
                    {t("messages.aml.related")}
                  </Button>
                </>
                }
                <Button
                  type="primary"
                  onClick={this.handleReport.bind(this)}
                  icon="file-excel"
                >
                  {t("messages.aml.export")}
                </Button>
              </div>
            </div>
          </PageHeader>
          <PageContent>
            <Sidebar>
              <Filters
                currentUser={currentUser}
                parametersClient={parametersClient}
                filters={filters}
                groups={groups}
                areas={areas}
                categories={categories}
                onChangeFilters={this.handleChangeFilters.bind(this)}
                origin="new"
              />
            </Sidebar>
            <Content>
              {currentUser.cliente.modules.includes("MONITOR-AML") && (
                <ContentTopBar
                  isLoading={isLoading}
                  firstLoading={firstLoading}
                  colors={colors}
                  colorsCake={colorsCake}
                  filters={filters}
                  onChangeFilters={this.handleChangeFilters.bind(this)}
                />
              )}

              <Row style={{ margin: 5 }}>
                <Col span={10}>
                  <Input.Search
                    value={filters?.text}
                    placeholder={t("messages.aml.searhcDniNameEmail")}
                    onChange={(e) =>
                      this.handleChangeFilters(
                        "text",
                        e.target.value,
                        e.target.value !== "",
                        false
                      )
                    }
                    onSearch={(value) =>
                      this.handleChangeFilters("text", value, value !== "")
                    }
                    allowClear
                  />
                </Col>
                <Col span={1}>
                  {(currentUser.modules.includes("ONBOARDING") ||
                    currentUser.modules.includes("CDI-FORM") ||
                    currentUser.modules.includes("QUIEBRA")) && (
                    <div
                      className={
                        isAdvancedSearchVisible
                          ? "advanced-search on"
                          : "advanced-search"
                      }
                      onClick={
                        !isAdvancedSearchVisible
                          ? () => {
                              this.setState({ isAdvancedSearchVisible: true });
                            }
                          : () => {
                              this.setState({ isAdvancedSearchVisible: false });
                            }
                      }
                    >
                      <Icon
                        style={{
                          fontSize: "20px",
                          marginTop: 5,
                          marginLeft: 10,
                          cursor: "pointer",
                        }}
                        type={!isAdvancedSearchVisible ? "filter" : "close"}
                      />
                    </div>
                  )}
                </Col>
                { currentUser.type !== "AUDIT" &&
                  <Col span={4} offset={9}>
                    <Dropdown
                      overlay={() => menu(selectedItems, "action")}
                      disabled={selectedItems.length === 0 && !isSendAll}
                    >
                      <Button style={{ float: "right" }}>
                        {t("messages.aml.alertAction")} <Icon type="down" />
                      </Button>
                    </Dropdown>
                  </Col>
                }
              </Row>

              <Row>
                <Col span={24}>
                  <div
                    className={
                      isAdvancedSearchVisible === null
                        ? "filters-wrapper null"
                        : isAdvancedSearchVisible
                        ? "filters-wrapper show"
                        : "filters-wrapper hide"
                    }
                  >
                    <div className="filters-wrapper-inner">
                      <AdvancedTabs
                        cbFilters={cbFilters}
                        filters={filters}
                        currentUser={currentUser}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="register-table">
                {chkAll && (
                  <Row>
                    <div className="select-all-container">
                      {isSendAll
                        ? t("messages.aml.allRecordsSelected", { count: totalCurrentUser })
                        : t("messages.aml.pageRecordsSelected") }
                      {(hasMultiplePages || isSendAll) && (
                        <span onClick={this.handleSelectAll.bind(this)}>
                          {isSendAll
                            ? t("messages.aml.clearSelection")
                            : t("messages.aml.selectAllRecords", { count: totalCurrentUser })}
                        </span>
                      )}
                    </div>
                  </Row>
                )}
                <Row>
                  <Table
                    size="small"
                    loading={isLoading}
                    pagination={false}
                    columns={getTableColumns()}
                    dataSource={clients}
                    indentSize={30}
                    rowKey="id12"
                  />
                </Row>

                {resultsTotalNum > 0 && (
                  <PageFooter>
                    <Pagination
                      current={currentPage}
                      total={resultsTotalNum}
                      onChange={this.handlePaginationChange.bind(this)}
                      pageSize={resultsPerPage}
                      showTotal={(total, range) =>
                        t("messages.aml.pagination.recordsRange", {
                          start: range[0],
                          end: range[1],
                          total,
                        })
                      }
                    />
                  </PageFooter>
                )}
              </div>
            </Content>
            <div style={{ clear: "both" }}></div>
          </PageContent>
        </Page>
        <PageBottomBar breadcrumbs={breadcrumbs} />

        {itemTable && (
            <Modal
            wrapClassName="modal-fichaCliente-register"
            style={{ top: "10px" }}
            title={
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                <span>{t('messages.aml.register')}</span>
                {this.state.modalTitleButtons}
              </div>
            }
            visible={true}
            onCancel={handleCancel}
            cancelText={t("messages.aml.btnClose")}
            footer={null}
            width={"95vw"}
          >
            <ModalClientCard
              key={itemTable.id}
              item={itemTable}
              handleCancel={handleCancel}
              currentUser={currentUser}
              areas={areasList}
              users={users}
              parametersClient={parametersClient}
              onTitleButtons={(buttons) => this.setState({ modalTitleButtons: buttons })}
            />
          </Modal>
        )}
        {isModalUploadVisible && (
          <Modal
            title={t("messages.aml.entityUpload")}
            className="modal-cliente"
            visible={isModalUploadVisible}
            onCancel={() => this.handleModalUploadClose()}
            footer={this.renderUploadModalFooter(
              this.handleUploadClient.bind(this),
              (
                <div className="plantilla">
                  <a onClick={() => this.downloadPlantilla("records")}>
                    {t("messages.aml.template")}
                  </a>
                </div>
              )
            )}
          >
            {uploading ? (
              this.renderUploadProgressContent()
            ) : uploaded ? (
              <List
                header={<h3>{t("messages.aml.results")}</h3>}
                bordered
                dataSource={resultsUpload}
                renderItem={(item) => <List.Item>{item}</List.Item>}
                footer={
                  bajaFiles && (
                    <Button
                      onClick={() => this.downloadBajaFile("resumen_registros.xlsx")}
                      icon="file-excel"
                    >
                      {t("messages.aml.downloadReport")}
                    </Button>
                  )
                }
              />
            ) : (
              <Form layout="vertical">
                {currentUser.cliente.modules.includes("MONITOR-AML") && (
                  <Form.Item label={t("messages.aml.asignedUser")}>
                    <Select
                      value={userAsig}
                      onChange={(value) =>
                        this.handleOnChangeAsignedUser(value)
                      }
                    >
                      {this.getUsersAsig(users)}
                    </Select>
                  </Form.Item>
                )}
                {currentUser.cliente.outsourcer &&
                  currentUser.cliente.clientes !== null &&
                  currentUser.cliente.clientes.length > 0 &&
                  currentUser.subcliente === null && (
                    <Form.Item label={t("messages.aml.subclient")}>
                      <Select
                        onChange={(value) =>
                          this.handleOnChangeSubcliente(value)
                        }
                        placeholder={t("messages.aml.selectCompany")}
                        className="subclient-dropdown-uploadclient"
                        allowClear
                      >
                        {currentUser.cliente.clientes.map((item) => (
                          <Select.Option
                            className="subclient-option"
                            value={item.id}
                          >
                            <div className="subclient-option-inner">
                              <figure className="subclient-logo">
                                <ImageResources
                                  url={getUrlPerson(item.id)}
                                  styleResource={{ height: "15px" }}
                                ></ImageResources>
                              </figure>
                              <span
                                className="subclient-name"
                                style={{ paddingLeft: "10px" }}
                              >
                                {item.name}
                              </span>
                            </div>
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                <Form.Item label={t("messages.aml.category")}>
                  <Select
                    onChange={(value) => this.handleOnChangeCategory(value)}
                    defaultValue="CLIENTE"
                  >
                    <Select.Option value="CLIENTE">
                      {t("messages.aml.category.CLIENTE")}
                    </Select.Option>
                    <Select.Option value="PROVEEDOR">
                      {t("messages.aml.category.PROVEEDOR")}
                    </Select.Option>
                    <Select.Option value="COLABORADOR">
                      {t("messages.aml.category.COLABORADOR")}
                    </Select.Option>
                    <Select.Option value="DIRECTOR">
                      {t("messages.aml.category.DIRECTOR")}
                    </Select.Option>
                  </Select>
                </Form.Item>
                {parametersClient !== null &&
                  parametersClient.gruposNames &&
                  parametersClient.gruposNames.length > 0 && (
                    <Form.Item label={t("messages.aml.group")}>
                      <Select
                        onChange={(value) => this.handleOnChangeGrupo(value)}
                        mode="multiple"
                      >
                        {parametersClient.gruposNames.map((grupo) => (
                          <Select.Option value={grupo}>{grupo}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                {currentUser.cliente.modules.includes("ADMCLI") &&
                  (currentUser.cliente.modules.includes("REG-ENTITY") ||
                    (!currentUser.cliente.modules.includes("REG-ENTITY") &&
                      !currentUser.cliente.modules.includes("REG-PERSON"))) &&
                  parametersClient &&
                  parametersClient.ubofinder &&
                  !parametersClient.ubofinder.noInvestigaMalla && (
                    <Row>
                      <Col xs={12}>
                        <Form.Item label={t("messages.aml.ubosInvestigate")}>
                          <Switch
                            checked={processUF}
                            onChange={(checked) =>
                              this.handleOnChangeUF(checked)
                            }
                          />
                        </Form.Item>
                      </Col>
                      {parametersClient.ubofinder.formularioInterno &&
                        !parametersClient.ubofinder.sinFormulario && (
                          <Col xs={12}>
                            <Form.Item label={t("messages.aml.sendMail")}>
                              <Switch
                                checked={!formularioInterno}
                                disabled={!processUF}
                                onChange={(checked) =>
                                  this.handleOnChangeSendMail(checked)
                                }
                              />
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                  )}
                {fileList.length === 0 ? (
                  <Form.Item>
                    <Dragger {...propsUpload}>
                      <img
                        src={uploadIcon}
                        alt=""
                        style={{ height: "100px" }}
                      />
                      <p className="ant-upload-text">
                        {t("messages.aml.clickHereOrDragExcel")}.
                      </p>
                    </Dragger>
                  </Form.Item>
                ) : (
                  <div className="file-wrapper">
                    <div className="file-inner">
                      <div className="image-wrapper">
                        <div className="remove">
                          <Icon
                            type="close"
                            onClick={() => this.setState({ fileList: [] })}
                          />
                        </div>
                        <img src={excelFileIcon} alt="" />
                      </div>
                      <p className="file-name">{fileList[0].name}</p>
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Modal>
        )}

        {isModalUploadInactiveVisible && (
          <Modal
            title={t("messages.aml.entityUploadInactivate")}
            className="modal-cliente"
            visible={isModalUploadInactiveVisible}
            onCancel={() => this.handleModalUploadClose()}
            footer={this.renderUploadModalFooter(
              this.handleUploadClientInactive.bind(this),
              (
                <div className="plantilla">
                  <a onClick={() => this.downloadPlantilla("massiveDownload")}>
                    {t("messages.aml.template")}
                  </a>
                </div>
              )
            )}
          >
            {uploading ? (
              this.renderUploadProgressContent()
            ) : uploaded ? (
              <List
                header={<h3>{t("messages.aml.results")}</h3>}
                bordered
                dataSource={resultsUpload}
                renderItem={(item) => <List.Item>{item}</List.Item>}
                footer={
                  bajaFiles && (
                    <Button
                      onClick={() => this.downloadBajaFile("resumen_baja_masiva.xlsx")}
                      icon="file-excel"
                    >
                      {t("messages.aml.downloadReport")}
                    </Button>
                  )
                }
              />
            ) : (
              <Form layout="vertical">
                {fileList.length === 0 ? (
                  <Form.Item>
                    <Dragger {...propsUploadExcelTxt}>
                      <img
                        src={uploadIcon}
                        alt=""
                        style={{ height: "100px" }}
                      />
                      <p className="ant-upload-text">
                        {t("messages.aml.clickHere.drag.excel.txt")}.
                      </p>
                    </Dragger>
                  </Form.Item>
                ) : (
                  <div className="file-wrapper">
                    <div className="file-inner">
                      <div className="image-wrapper">
                        <div className="remove">
                          <Icon
                            type="close"
                            onClick={() => this.setState({ fileList: [] })}
                          />
                        </div>
                        <img src={excelFileIcon} alt="" />
                      </div>
                      <p className="file-name">{fileList[0].name}</p>
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Modal>
        )}
        {isModalUploadRelatedVisible && (
          <Modal
            title={t("messages.aml.related")}
            className="modal-cliente"
            visible={isModalUploadRelatedVisible}
            onCancel={() => this.handleModalUploadClose()}
            footer={this.renderUploadModalFooter(
              this.handleUploadRelatedFile.bind(this),
              (
                <div className="plantilla">
                  <a onClick={() => this.downloadPlantilla("related")}>
                    {t("messages.aml.template")}
                  </a>
                </div>
              )
            )}
          >
            {uploading ? (
              this.renderUploadProgressContent()
            ) : uploaded ? (
              <List
                header={<h3>{t("messages.aml.results")}</h3>}
                bordered
                dataSource={resultsUpload}
                renderItem={(item) => <List.Item>{item}</List.Item>}
                footer={
                  bajaFiles && (
                    <Button
                      onClick={() => this.downloadBajaFile("resumen_relacionados.xlsx")}
                      icon="file-excel"
                    >
                      {t("messages.aml.downloadReport")}
                    </Button>
                  )
                }
              />
            ) : (
              <Form layout="vertical">
                {fileList.length === 0 ? (
                  <Form.Item>
                    <Dragger {...propsUploadExcelTxt}>
                      <img
                        src={uploadIcon}
                        alt=""
                        style={{ height: "100px" }}
                      />
                      <p className="ant-upload-text">
                        {t("messages.aml.clickHere.drag.excel.txt")}.
                      </p>
                    </Dragger>
                  </Form.Item>
                ) : (
                  <div className="file-wrapper">
                    <div className="file-inner">
                      <div className="image-wrapper">
                        <div className="remove">
                          <Icon
                            type="close"
                            onClick={() => this.setState({ fileList: [] })}
                          />
                        </div>
                        <img src={excelFileIcon} alt="" />
                      </div>
                      <p className="file-name">{fileList[0].name}</p>
                    </div>
                  </div>
                )}
              </Form>
            )}
          </Modal>
        )}
        {isModalRiskVisible && (
          <Modal
            title={t("messages.aml.risk")}
            visible={true}
            onCancel={this.handleOnCancelModalRisk.bind(this)}
            width={900}
            footer={[
              <Button onClick={this.handleOnCancelModalRisk.bind(this)}>
                {t("messages.aml.btnClose")}
              </Button>,
            ]}
          >
            <ModalRisk
              key={Math.floor(Math.random() * 100 + 1)}
              record={selectedRecord}
            />
          </Modal>
        )}
        {isModalUbosVisible && (
          <Modal
            key={Math.floor(Math.random() * 100 + 1)}
            title={t("messages.aml.finalBeneficiaries")}
            visible={true}
            onCancel={this.handleOnCancelModalUbos.bind(this)}
            width={1100}
            footer={[
              <Button onClick={this.handleOnCancelModalUbos.bind(this)}>
                {t("messages.aml.btnClose")}
              </Button>,
            ]}
          >
            <ModalUbos record={selectedRecord} currentUser={currentUser} />
          </Modal>
        )}
        {isModalReportVisible && (
          <Modal
            title={t("messages.aml.export")}
            visible={true}
            onCancel={this.handleOnCancelModalReport.bind(this)}
            width={500}
            footer={[
              <Button onClick={this.handleOnCancelModalReport.bind(this)}>
                {t("messages.aml.btnClose")}
              </Button>,
            ]}
          >
            <div style={{ textAlign: "center" }}>
              <Button
                onClick={this.handleExcelReport.bind(this)}
                disabled={
                  isLoadingExport ||
                  isLoadingRisk ||
                  isLoadingCertificates ||
                  isLoadingBfReport ||
                  isLoadingMp ||
                  isLoadingFormReport
                }
                icon={isLoadingExport ? "loading" : "file-excel"}
              >
                {t("messages.aml.export")}
              </Button>
              <br />
              <br />
              {currentUser.cliente.modules.includes("MONITOR-AML") && (
                <>
                  <Button
                    onClick={this.handleRiskReport.bind(this)}
                    disabled={
                      isLoadingExport ||
                      isLoadingRisk ||
                      isLoadingCertificates ||
                      isLoadingBfReport ||
                      isLoadingMp ||
                      isLoadingFormReport
                    }
                    icon={isLoadingRisk ? "loading" : "file-excel"}
                  >
                    {t("messages.aml.riskLevels")}
                  </Button>
                  <br />
                  <br />
                </>
              )}
              <Button
                onClick={this.handlePDFReport.bind(this)}
                disabled={
                  isLoadingExport ||
                  isLoadingRisk ||
                  isLoadingCertificates ||
                  isLoadingBfReport ||
                  isLoadingMp ||
                  isLoadingFormReport
                }
                icon={isLoadingCertificates ? "loading" : "file-pdf"}
              >
                {t("messages.aml.certificates")}
              </Button>
              {currentUser.cliente.modules.includes("ADMCLI") &&
                parametersClient &&
                parametersClient.ubofinder &&
                !parametersClient.ubofinder.noInvestigaMalla && (
                  <>
                    <br />
                    <br />
                    <Button
                      onClick={this.handleBFReport.bind(this)}
                      disabled={
                        isLoadingExport ||
                        isLoadingRisk ||
                        isLoadingCertificates ||
                        isLoadingBfReport ||
                        isLoadingMp ||
                        isLoadingFormReport
                      }
                      icon={isLoadingBfReport ? "loading" : "profile"}
                    >
                      {t("messages.aml.finalBeneficiaries")}
                    </Button>
                    <br />
                    <br />
                    <Button
                      onClick={this.handleMallasPropiedadReport.bind(this)}
                      disabled={
                        isLoadingExport ||
                        isLoadingRisk ||
                        isLoadingCertificates ||
                        isLoadingBfReport ||
                        isLoadingMp ||
                        isLoadingFormReport
                      }
                      icon={isLoadingMp ? "loading" : "profile"}
                    >
                      {t("messages.aml.ownershipTree")}
                    </Button>
                    {!parametersClient.ubofinder.sinFormulario && (
                      <>
                        <br />
                        <br />
                        <Button
                          onClick={this.handleFormsReport.bind(this)}
                          disabled={
                            isLoadingExport ||
                            isLoadingRisk ||
                            isLoadingCertificates ||
                            isLoadingBfReport ||
                            isLoadingMp ||
                            isLoadingFormReport
                          }
                          icon={isLoadingFormReport ? "loading" : "file-pdf"}
                        >
                          {t("messages.aml.ubofinder.forms")}
                        </Button>
                      </>
                    )}
                  </>
                )}
            </div>
          </Modal>
        )}
        {recordsAction.length > 0 && (
          <Modal
            title={actionTypeRender[actionType]}
            centered={true}
            width={500}
            footer={false}
            onCancel={handleCancel}
            visible={true}
          >
            <ModalRequestOpt
              type={actionType}
              recipients={recordsAction}
              handleCancel={handleCancel}
              currentUser={currentUser}
              isSendAll={isSendAll}
              totalCurrentUser={totalCurrentUser}
              filterCurrentUser={filterCurrentUser}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default withTranslation()(withRouter(Register));
